function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Align-left-1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M9.995,1.209H1.011A1.015,1.015,0,0,0,0,2.212v.407A1.011,1.011,0,0,0,1.011,3.628H9.995a1.011,1.011,0,0,0,1.011-1.009V2.211A1.015,1.015,0,0,0,9.995,1.209Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M12.99,5.79H1.011A1.016,1.016,0,0,0,0,6.793V7.2A1.011,1.011,0,0,0,1.011,8.21H12.99A1.01,1.01,0,0,0,14,7.2V6.792A1.014,1.014,0,0,0,12.99,5.79Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M6.5,10.372H1.011a1.015,1.015,0,0,0-1.011,1v.406a1.011,1.011,0,0,0,1.011,1.01H6.5a1.011,1.011,0,0,0,1.011-1.01v-.407A1.015,1.015,0,0,0,6.5,10.372Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/align-left.618c5cc0.svg";
export { SvgComponent as ReactComponent };